
import { Component } from 'preact';
import { FrameItem, framesStore } from '../store/frames';
import { effect, signal } from '@preact/signals';
import { Drawer } from 'flowbite';
import ExternalBlock from './ExternalBlock';
import { route } from 'preact-router';
export default class ReserveFrameDialog extends Component {

    private popoverReserveDialog!: Drawer;
    private privacyChecked = signal<boolean>(false);
    private reserveState = signal<'basket'|'select-date'>('basket');
  
    constructor() {
        super();
        const notepadButton = document.querySelector('#notepad-button');
        const notepadButtonBadge = document.querySelector('.notepad-button-wrapper > div.badge');
        if(notepadButton && notepadButtonBadge) {
            notepadButton.addEventListener('click', () => {
                this.reserveState.value = 'basket';
                this.popoverReserveDialog.show();
                framesStore.reservedDialogOpen.value = true;
            });
            effect(() => {
                const count = framesStore.reservedFrameList.value.length;
                if (count > 0) {
                notepadButton.querySelector('img')!.src= './images/notepad-and-pen-svgrepo-com.svg';
                notepadButtonBadge.classList.remove('hidden');
                //notepadButton.classList.remove("grayscale");
                } else {
                notepadButton.querySelector('img')!.src= './images/outdoor-trip-schedule-svgrepo-com.svg';
                //notepadButton.classList.add("grayscale");
                notepadButtonBadge.classList.add('hidden');
                }
                if (notepadButtonBadge) {
                
                notepadButtonBadge.innerHTML = '' + count;
                }
            });
        }
        
    }



    
      onPrivacyChange(e: Event) {
        this.privacyChecked.value = (e.target as HTMLInputElement).checked;
      }
    
      remove(frame: FrameItem) {
        framesStore.removeFrameFromReservedList(frame);
      }
    
      selectDate() {
        this.reserveState.value = 'select-date';
      }

      openFrame(no: string) {
        framesStore.reservedDialogOpen.value = false;
        route('/brille/' + no);
      }
     
    
      componentDidMount(): void {
        const reserveFrameDialog = document.getElementById('reserve-frame-dialog');
        if (reserveFrameDialog) {
            this.popoverReserveDialog = new Drawer(reserveFrameDialog, {
                backdrop: true,
                //backdropClasses: 'bg-black',
                placement: 'right',
                onHide: () => {
                    framesStore.reservedDialogOpen.value = false;
                    reserveFrameDialog.classList.add('hidden');
                },
                onShow: () => {
                  this.reserveState.value = 'basket';
                  reserveFrameDialog.classList.remove('hidden');
                },
            });
        }
        effect(() => {
          if (framesStore.reservedDialogOpen.value) {
            this.popoverReserveDialog.show();
          } else {
            this.popoverReserveDialog.hide();
          }
        });
      }
    
    render() {
        return <div id="reserve-frame-dialog" class="hidden fixed top-0 right-0 z-40 h-screen p-4 overflow-y-auto transition-transform translate-x-full bg-white w-100 dark:bg-gray-800" tabindex="-1" aria-labelledby="drawer-right-label">
                        <h5 id="drawer-right-label" class="inline-flex items-center mb-4 text-base font-semibold text-gray-500 dark:text-gray-400"><svg class="w-4 h-4 me-2.5" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"/>
                        </svg>{framesStore.reservedFrameList.value.length === 0 ? 'Termin buchen' : 'Reservierung'}</h5>
                        <button type="button" data-drawer-hide="reserve-frame-dialog" aria-controls="reserve-frame-dialog" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white" >
                            <svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                            </svg>
                            <span class="sr-only">Close menu</span>
                        </button>
        
                    <div id="reserve-frame-content">
                    { this.reserveState.value === 'basket' ? <div id="basket">
                      {framesStore.reservedFrameList.value.length === 0 ? <div id="date-only-text">
                         <h2 class="text-neutral-800 text-lg">Gerne reservieren wir uns für Sie extra Zeit.<br />Wählen Sie dazu einen Termin aus.</h2>
                      </div> : 
                            <ul class="flex flex-col gap-y-2">
                                {framesStore.reservedFrameList.value.map(frame => {
                                    return <li class="flex gap-x-4 items-center">
                                        <img src={frame.thumbnail} class="w-[100px] h-auto rounded-xl overflow-hidden drop-shadow-lg" />
                                        <div class="grow">
                                            <h3 class="font-bold text-xl" dangerouslySetInnerHTML={{__html: frame.name}}></h3>
                                            Modell: {frame.no}<br />
                                            <a onClick={() => this.openFrame(frame.no)} class="underline cursor-pointer">Brille ansehen</a>
                                        </div>
                                        <div>
                                            <button type="button" onClick={() => this.remove(frame)} class="text-neutral-600 p-2 hover:text-durchblick-primary rounded hover:bg-neutral-100">
                                                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5 7.5H19L18 21H6L5 7.5Z" stroke="currentColor" stroke-linejoin="round"/>
                                                <path d="M15.5 9.5L15 19" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M12 9.5V19" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.5 9.5L9 19" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M16 5H19C20.1046 5 21 5.89543 21 7V7.5H3V7C3 5.89543 3.89543 5 5 5H8M16 5L15 3H9L8 5M16 5H8" stroke="currentColor" stroke-linejoin="round"/>
                                                </svg>
                                            </button>
                                        </div>
                                    </li>;
                                })}
                            </ul>
                            }
                            
        
                            
                            <div class="mt-8 text-sm text-neutral-500" id="privacy-info-checkbox-text">Für die Termin auswahl und Speicherung nutzen wir die externen Anbieter: Zeeg (Deutschland) und Google Inc (USA).</div>
                            <div class="flex items-center my-4">
                                <input id="default-checkbox" type="checkbox" value="" onChange={(e) => this.onPrivacyChange(e)} class="w-4 h-4 text-lime-600 bg-gray-100 border-gray-300 rounded focus:ring-lime-500 dark:focus:ring-lime-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600" />
                                <label for="default-checkbox" class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300">Ja, ich Stimme der Datenschutzerklärung zu.</label>
                            </div>
                        
        
                            <div class="flex justify-end items-center gap-x-2 mt-4">
                                {this.privacyChecked.value ? '' : <p class="text-red-500">Bitte stimmen Sie zu erst unser Datenschutzerklärung zu.</p>}
                                <button disabled={!this.privacyChecked.value} onClick={() => this.selectDate()} class="text-durchblick-primary border-2 border-durchblick-primary hover:border-lime-400
                                    focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex gap-x-2 items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 
                                    disabled:border-gray-300 disabled:bg-neutral-100 disabled:text-neutral-300" type="button">
                                    <svg height="24" width="24" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" 
                                            viewBox="0 0 41.389 41.389" xml:space="preserve">
                                        <g>
                                            <path style="fill:currentColor;" d="M34.591,0.474c-2.822,0-5.161,2.054-5.634,4.741H17.396c-0.474-2.688-2.812-4.741-5.634-4.741
                                                c-2.823,0-5.161,2.054-5.635,4.741H4.139C1.853,5.215,0,7.069,0,9.354v31.561h37.25c2.286,0,4.139-1.854,4.139-4.139V5.216h-1.163
                                                C39.752,2.528,37.413,0.474,34.591,0.474z M30.005,9.614c0.149,0.197,0.291,0.401,0.466,0.582c0.202,0.21,0.473,0.314,0.742,0.314
                                                c0.26,0,0.52-0.096,0.721-0.29c0.411-0.398,0.421-1.054,0.022-1.464c-0.249-0.256-0.441-0.554-0.603-0.863
                                                c0.215-0.076,0.438-0.137,0.679-0.137c1.143,0,2.069,0.926,2.069,2.068c0,1.145-0.926,2.07-2.069,2.07s-2.069-0.926-2.069-2.07
                                                C29.963,9.752,29.999,9.686,30.005,9.614z M11.761,2.545c1.674,0,3.075,1.135,3.511,2.671H8.25
                                                C8.687,3.68,10.087,2.545,11.761,2.545z M7.022,9.423c0.185,0.27,0.386,0.533,0.619,0.774c0.202,0.21,0.473,0.314,0.743,0.314
                                                c0.26,0,0.52-0.096,0.721-0.29c0.41-0.398,0.42-1.054,0.022-1.464C8.869,8.49,8.67,8.181,8.506,7.858
                                                C8.672,7.816,8.831,7.757,9.01,7.757c1.143,0,2.069,0.926,2.069,2.068c0,1.145-0.926,2.07-2.069,2.07
                                                c-1.142,0-2.069-0.926-2.069-2.07C6.94,9.682,6.994,9.557,7.022,9.423z M37.594,34.188c0,1.145-0.927,2.07-2.069,2.07H3.448V16.77
                                                c0-1.145,0.926-2.069,2.07-2.069h32.076V34.188z M31.08,5.216c0.437-1.536,1.837-2.671,3.511-2.671s3.075,1.135,3.512,2.671H31.08z
                                                "/>
                                            <path style="fill:currentColor;" d="M11.761,20.026v-3.541H7.8v1.641H6.151v3.97h3.541C10.835,22.095,11.761,21.17,11.761,20.026z"/>
                                            <path style="fill:currentColor;" d="M19.586,20.026v-3.541h-3.961v1.641h-1.649v3.97h3.541C18.66,22.095,19.586,21.17,19.586,20.026z"/>
                                            <path style="fill:currentColor;" d="M27.411,20.026v-3.541H23.45v1.641h-1.649v3.97h3.541C26.485,22.095,27.411,21.17,27.411,20.026z"/>
                                            <path style="fill:currentColor;" d="M35.236,20.026v-3.541h-3.961v1.641h-1.649v3.97h3.541C34.31,22.095,35.236,21.17,35.236,20.026z"/>
                                            <path style="fill:currentColor;" d="M11.761,26.605v-3.54H7.8v1.641H6.151v3.969h3.541C10.835,28.675,11.761,27.75,11.761,26.605z"/>
                                            <path style="fill:currentColor;" d="M19.586,26.605v-3.54h-3.961v1.641h-1.649v3.969h3.541C18.66,28.675,19.586,27.75,19.586,26.605z"/>
                                            <path style="fill:currentColor;" d="M27.411,26.605v-3.54H23.45v1.641h-1.649v3.969h3.541C26.485,28.675,27.411,27.75,27.411,26.605z"/>
                                            <path style="fill:currentColor;" d="M35.236,26.605v-3.54h-3.961v1.641h-1.649v3.969h3.541C34.31,28.675,35.236,27.75,35.236,26.605z"/>
                                            <path style="fill:currentColor;" d="M11.761,33.332v-3.541H7.8v1.642H6.151v3.969h3.541C10.835,35.401,11.761,34.475,11.761,33.332z"/>
                                            <path style="fill:currentColor;" d="M19.586,33.332v-3.541h-3.961v1.642h-1.649v3.969h3.541C18.66,35.401,19.586,34.475,19.586,33.332z"
                                                />
                                            <path style="fill:currentColor;" d="M27.411,33.332v-3.541H23.45v1.642h-1.649v3.969h3.541C26.485,35.401,27.411,34.475,27.411,33.332z"
                                                />
                                            <path style="fill:currentColor;" d="M35.236,33.332v-3.541h-3.961v1.642h-1.649v3.969h3.541C34.31,35.401,35.236,34.475,35.236,33.332z"
                                                />
                                        </g>
                                        </svg>
                                    Termin auswählen
                                </button>
                            </div>
                        </div>
                        :
                        <ExternalBlock>
                
                        </ExternalBlock>
                    }
                    </div>
        
                 
        </div>
    }
}